"use client";
import { localStore, sessionStore } from "@/utils/storage";

import { useEffect, useRef } from "react";
import { usePathname } from "next/navigation";

const RouteChangeHandler = () => {
  const pathname = usePathname();
  const prevPathname = useRef(pathname);

  // useEffect(() => {
  //   if (prevPathname.current !== pathname) {
  //     localStore.remove("loanFormData");
  //     localStore.remove("currentSteps");
  //     localStore.remove("currentStep");
  //     localStore.remove("isAllStepsCompleted");
  //     localStore.remove("enableBankingFormData");
  //     localStore.remove("enableBankingStep");
  //     localStore.remove("localEnableBankingData");
  //     localStore.remove("bank_name");
  //     localStore.remove("sessionId");
  //     localStore.remove("bank_no");
  //     localStore.remove("bankAccountNumbers");
  //     localStore.remove("selectedOrganization");
  //     localStore.remove("checkedConsentItems");
  //     localStore.remove("selectedBank");
  //     localStore.remove("selectedBankId");
  //     localStore.remove("isEnableBankingLastStep");
  //     localStore.remove("loanApplicationId");
  //     // removed enable baniking steps
  //     sessionStore.remove("currentStep");
  //     sessionStore.remove("currentSteps");
  //     sessionStore.remove("isAllStepsCompleted");
  //     sessionStore.remove("loanFormData");
  //     localStore.remove("isShowSubmitButton");
  //     localStore.remove("hasShownCreditToast");
  //     localStore.remove("hasShownEbToast");
  //     // local storage data related enablebanking url link
  //     localStore.remove("applicationData");
  //     prevPathname.current = pathname;
  //   }
  // }, [pathname]);

  return null;
};

export default RouteChangeHandler;
